import { APIResponse } from "@/types/api";
import http from "@/composables/api";
import { CategoryStorePayload, CategoryStoreResponse } from "@/types/interface/category-store";
import { ref } from "vue";
import { db } from "@/database/db";

const loginInfo = ref();
const stringLoginInfo = await db.storage.get('login-info');
loginInfo.value = stringLoginInfo?.data;

async function createCategoryStore(payload: CategoryStorePayload) {
  return await http.post<APIResponse<CategoryStoreResponse>>("category/create", payload);
}

async function updateCategoryStore(idCategoryStore = '', payload: CategoryStorePayload) {
  return await http.patch<APIResponse<CategoryStoreResponse>>(`category/update?id=${idCategoryStore}`, payload);
}

async function getCategoryStore(page = 1, limit = 10, queryParam = "") {
  let pagination = true;
  if (page == 0){
    pagination = false;
  }
  if (loginInfo?.value?.job?.id != undefined){
    queryParam = queryParam + '&job_id=' + loginInfo?.value?.job?.id;
  }
  return await http.get<APIResponse<CategoryStoreResponse>>(`category?is_pagination=${pagination}&page=${page}&limit=${limit}${queryParam}`);
}

async function findCategoryStore(idCategoryStore = "") {
  return await http.get<APIResponse<CategoryStoreResponse>>(`category/detail?id=${idCategoryStore}`);
}

async function deleteCategoryStore(idCategoryStore = "") {
  return await http.delete<APIResponse<CategoryStoreResponse>>(`category/delete?id=${idCategoryStore}`);
}

export default {
  createCategoryStore,
  updateCategoryStore,
  getCategoryStore,
  findCategoryStore,
  deleteCategoryStore
};